import React from "react";
import "./services.css";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Do</h5>
      <h2>Services</h2>
      <div className="container services_container">
        <article className="service">
          <div className="service_head">
            <h3>Web Development</h3>
          </div>
          <ul className="service_list">
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Developing end-to-end web applications using front-end and back-end technologies</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Ensuring code quality, maintainability, and scalability through design patterns</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Collaborating with designers to translate designs into functional & responsive apps.</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Implementing secure data handling, user authentication & authorization mechanisms</p>
            </li>

          </ul>
        </article>

        <article className="service">
          <div className="service_head">
            <h3>DevOps</h3>
          </div>
          <ul className="service_list">
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Automating and streamlining the development, testing, and deployment processes.</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Configuring cloud infrastructure, containers, & orchestration platforms.</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Implementing CI/CD pipelines to enable faster & more reliable software releases.</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Optimizing performance & security through logging & monitoring tools.</p>
            </li>

          </ul>
        </article>

        <article className="service">
          <div className="service_head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className="service_list">
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Crafting intuitive & visually appealing user interfaces to enhance the user experience</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Optimizing website layout, typography,to improve accessibility and usability.</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Incorporating latest design trends & best practices to create engaging experiences.</p>
            </li>
            <li>
              <IoMdCheckmarkCircleOutline className="service_list_icon" />
              <p>Creating wireframes, and prototyping to validate design decisions.</p>
            </li>

          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;
